import { render, staticRenderFns } from "./ManualSubscriptionPlanCard.vue?vue&type=template&id=8b96ca0c&scoped=true&"
import script from "./ManualSubscriptionPlanCard.vue?vue&type=script&lang=js&"
export * from "./ManualSubscriptionPlanCard.vue?vue&type=script&lang=js&"
import style0 from "./ManualSubscriptionPlanCard.vue?vue&type=style&index=0&id=8b96ca0c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b96ca0c",
  null
  
)

export default component.exports